import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import ctaBackground from '../assets/images/hero/2.jpg';
import CustomButton from './common/CustomButton';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${ctaBackground})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  width: '100%',
  padding: '100px 0',
  color: '#ffffff',
}));

const CTA2Section = () => {
  return (
    <StyledBox>
      <Container maxWidth="lg">
        <Typography
          variant="h5"
          sx={{
            fontSize: { xs: '1.5rem', md: '1.75rem' },
            fontWeight: 500,
            marginBottom: '1.5rem',
            color: '#ffffff',
            letterSpacing: '0.5px',
            opacity: 0.9,
          }}
        >
          Contactez-nous
        </Typography>
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontSize: { xs: '2.75rem', md: '4rem' },
            fontWeight: 700,
            marginBottom: '3rem',
            maxWidth: '900px',
            color: '#ffffff',
            lineHeight: 1.1,
          }}
        >
          Optimisez vos processus de mesures et votre performance industrielle
        </Typography>
        <CustomButton
          component="a"
          href="/contact"
          variant="contained"
          size="large"
          sx={{
            backgroundColor: '#004B87',
            fontSize: { xs: '1.1rem', md: '1.25rem' },
            padding: '12px 40px',
            '&:hover': {
              backgroundColor: '#003A69',
            },
          }}
        >
          Demander un devis
        </CustomButton>
      </Container>
    </StyledBox>
  );
};

export default CTA2Section;
